"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThumbnailLabel = void 0;
const getThumbnailLabel = ({ media, videoButtonLabel, visualiserButtonLabel }) => {
    const isVideo = media?.isVideo;
    const isVisualiser = !!media?.visualiserParameters;
    if (isVideo) {
        return videoButtonLabel;
    }
    else if (isVisualiser) {
        return visualiserButtonLabel;
    }
    return undefined;
};
exports.getThumbnailLabel = getThumbnailLabel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbWVkaWEtZ2FsbGVyeS91dGlscy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFRTyxNQUFNLGlCQUFpQixHQUFHLENBQUMsRUFDaEMsS0FBSyxFQUNMLGdCQUFnQixFQUNoQixxQkFBcUIsRUFDZixFQUFFLEVBQUU7SUFDVixNQUFNLE9BQU8sR0FBRyxLQUFLLEVBQUUsT0FBTyxDQUFDO0lBQy9CLE1BQU0sWUFBWSxHQUFHLENBQUMsQ0FBQyxLQUFLLEVBQUUsb0JBQW9CLENBQUM7SUFFbkQsSUFBSSxPQUFPLEVBQUUsQ0FBQztRQUNaLE9BQU8sZ0JBQWdCLENBQUM7SUFDMUIsQ0FBQztTQUFNLElBQUksWUFBWSxFQUFFLENBQUM7UUFDeEIsT0FBTyxxQkFBcUIsQ0FBQztJQUMvQixDQUFDO0lBQ0QsT0FBTyxTQUFTLENBQUM7QUFDbkIsQ0FBQyxDQUFDO0FBZFcsUUFBQSxpQkFBaUIscUJBYzVCIn0=